var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.08 6.66C33.6337 4.78313 29.1075 3.75 24.33 3.75C19.5525 3.75 15.0262 4.78313 11.58 6.66C7.71183 8.77313 5.57996 11.7337 5.57996 15V33C5.57996 36.2663 7.71183 39.2269 11.58 41.34C15.0206 43.215 19.5468 44.25 24.33 44.25C29.1131 44.25 33.6337 43.2169 37.08 41.34C40.9537 39.2269 43.08 36.2663 43.08 33V15C43.08 11.7337 40.9481 8.77313 37.08 6.66ZM38.58 24C38.58 27.1875 32.7281 30.75 24.33 30.75C15.9318 30.75 10.08 27.1875 10.08 24V22.4137C10.5633 22.7487 11.064 23.0579 11.58 23.34C15.0206 25.215 19.5468 26.25 24.33 26.25C29.1131 26.25 33.6337 25.2169 37.08 23.34C37.5959 23.0579 38.0966 22.7487 38.58 22.4137V24ZM24.33 8.25C32.7281 8.25 38.58 11.8125 38.58 15C38.58 18.1875 32.7281 21.75 24.33 21.75C15.9318 21.75 10.08 18.1875 10.08 15C10.08 11.8125 15.9318 8.25 24.33 8.25ZM24.33 39.75C15.9318 39.75 10.08 36.1875 10.08 33V31.4137C10.5633 31.7487 11.064 32.0579 11.58 32.34C15.0206 34.215 19.5468 35.25 24.33 35.25C29.1131 35.25 33.6337 34.2169 37.08 32.34C37.5959 32.0579 38.0966 31.7487 38.58 31.4137V33C38.58 36.1875 32.7281 39.75 24.33 39.75Z",
    fill: "url(#paint0_linear_1559_116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_116",
    x1: 24.33,
    y1: 3.75,
    x2: 24.33,
    y2: 44.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.8620e0b0aa08e9cfdb3fc58a078d5ede.svg";
export { ForwardRef as ReactComponent };